import { useState } from 'react'

export function useOrderTable(array, initialValue, initialOrder) {
  const [orderType, setOrderType] = useState({
    field: initialValue,
    type: initialOrder || 'desc',
  })

  const sortedArray = array.sort((a, b) => {
    const aValue = a[orderType.field]
    const bValue = b[orderType.field]

    // Verifica se os valores são datas válidas
    const aDate = new Date(aValue)
    const bDate = new Date(bValue)
    const isDate = !isNaN(aDate.getTime()) && !isNaN(bDate.getTime())

    // Comparação de acordo com o tipo de dado
    if (isDate) {
      if (orderType.type === 'desc') {
        return bDate - aDate
      } else {
        return aDate - bDate
      }
    } else {
      // Considerando os valores como strings para comparação
      if (orderType.type === 'desc') {
        return String(bValue).trim().localeCompare(String(aValue).trim())
      } else {
        return String(aValue).trim().localeCompare(String(bValue).trim())
      }
    }
  })

  function handleOrganize(field) {
    setOrderType((prevState) => {
      if (prevState.field !== field) {
        return {
          field,
          type: 'asc',
        }
      } else {
        return {
          field,
          type: prevState.type === 'asc' ? 'desc' : 'asc',
        }
      }
    })
  }

  function check(field, type) {
    if (field === orderType.field) {
      if (orderType.type === type) {
        if (type === 'asc') {
          return 'green'
        } else {
          return 'red'
        }
      }
    }

    return
  }

  return {
    handleOrganize,
    check,
    orderType,
    sortedArray,
  }
}
